import { useEffect, useState } from "react";
import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import Alert from './components/Alert';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Toaster, toast } from 'react-hot-toast';

function App() {
  const notify = (mssg) => toast.success(mssg);

  useEffect(() => {
    const disableDevTools = (event) => {
      if (
        (event.ctrlKey && event.shiftKey && event.key === "I") ||
        (event.ctrlKey && event.shiftKey && event.key === "J") ||
        (event.ctrlKey && event.key === "U") ||
        (event.key === "F12") ||
        (event.ctrlKey && event.shiftKey && event.key === "C")
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", disableDevTools);
    document.addEventListener("contextmenu", (event) => event.preventDefault());

    return () => {
      document.removeEventListener("keydown", disableDevTools);
      document.removeEventListener("contextmenu", (event) => event.preventDefault());
    };
  }, []);

  const [mode, setMode] = useState('light');
  // eslint-disable-next-line
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    notify(message);
  };

  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#042743';
      showAlert("Dark mode has been enabled", "success");
    } else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      showAlert("Light mode has been enabled", "success");
    }
  };

  return (
    <>
      <Router>
        <Navbar title="TextXpert" mode={mode} toggleMode={toggleMode} key={new Date()} />
        <Alert alert={alert} />
        <div className="container my-3">
          <Switch>
            <Route exact path="/">
              <TextForm showAlert={showAlert} heading="Try TextXpert - word counter, character counter, remove extra spaces" mode={mode} />
            </Route>
          </Switch>
        </div>
      </Router>
      
      <Toaster
        // position="bottom-right"
        toastOptions={{
          duration: 5000,
          style: {
            background: mode === 'dark' ? '#333' : '#fff',
            color: mode === 'dark' ? '#fff' : '#000',
          }
        }}
      />
    </>
  );
}

export default App;
